'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    invariant = require('react/lib/invariant'),
    assign = require('react/lib/Object.assign');

var NavigationActionCreators = {
  setContext(id, options) {
    invariant(
      NavigationContextTypes.hasOwnProperty(id),
      'set() accepts a constant from NavigationContextTypes. You passed %s',
      id
    );

    AppDispatcher.handleViewAction({
      type: ActionTypes.SET_NAVIGATION_CONTEXT,
      context: assign({ id: id }, options)
    });
  },

  clearContext() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.CLEAR_NAVIGATION_CONTEXT
    });
  }
};

module.exports = NavigationActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/NavigationActionCreators.js
 **/